export default __webpack_public_path__ + "static/media/Group2.7e560838.svg";